/**
 * lucide-react v0.209.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const BookLock = createLucideIcon("BookLock", [
  ["path", { d: "M4,19.5C4,18.1,5.1,17,6.5,17H20", key: "dolp24" }],
  ["path", { d: "M18,6V4c0-1.1-0.9-2-2-2s-2,0.9-2,2v2", key: "t07v6p" }],
  [
    "path",
    {
      d: "M20,15v7H6.5C5.1,22,4,20.9,4,19.5v-15C4,3.1,5.1,2,6.5,2H10",
      key: "1671xw"
    }
  ],
  [
    "path",
    {
      d: "M13,6h6c0.6,0,1,0.4,1,1v3c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1V7C12,6.4,12.4,6,13,6z",
      key: "bih03q"
    }
  ]
]);

export { BookLock as default };
//# sourceMappingURL=book-lock.js.map
